const skillLevels: object[] = [
  {
    value: 'junior',
    label: 'Junior',
    description: 'Meno di e anni di esperienza',
  },
  {
    value: 'middle',
    label: 'Middle',
    description: 'Fra i 3 e 6 anni di esperienza',
  },
  {
    value: 'senior',
    label: 'Senior',
    description: 'Più di 7 anni di esperienza',
  },
];
export default skillLevels;
